import AuthenticationAPI from '../../api/authentication';
import MonetizationAPI from '../../api/monetization';
import ClientAPI from '../../api/client';
import LearnerDataAPI from '../../api/learner-data';
import LearnerDataItlAPI from '../../api/learner-data-itl';
import BigdefAPI from '../../api/bigdef';
import BigdefItlApi from '../../api/bigdef-itl';
import publicApiUrl from '../../api/public-api-url';
import CrossWindowRPC from '../rpc';
import { EVENT_NAME_LOCATION_CHANGE } from '../constants';

const parentWindow = {};

const api = {
  authentication: AuthenticationAPI(`${publicApiUrl}/client/users`),
  monetization: MonetizationAPI(),
  client: ClientAPI(`${publicApiUrl}/client`, parentWindow),
  learnerData: LearnerDataAPI(`${publicApiUrl}/learner_data`),
  learnerDataItl: LearnerDataItlAPI(),
  bigdef: BigdefAPI(),
  bigdefItl: BigdefItlApi()
};

CrossWindowRPC({ window: window.parent, origin: '*' }, (method, ...params) => {
  if (method === EVENT_NAME_LOCATION_CHANGE) {
    [parentWindow.location] = params;
    return;
  }

  const [type, endpoint] = method.split('.');
  return api[type][endpoint](...params)
    .catch((error) => {
      if (error.response) {
        const { status, data } = error.response;
        throw {
          response: { status, data }
        };
      } else {
        throw error;
      }
    });
});
